export default __webpack_public_path__ + "static/media/mild-and-gentle-formulation.b6570960.svg";